export const FEATURE_NAME = 'previewsArchive';
export const PREVIEWS_SIZE_TO_DOWNLOAD = 3000;
